import { client, getUrl } from "../../../../utils";

export const getConfigsRequest = (filterParams) => client.get(getUrl("configs", filterParams));

export const patchConfigRequest = ({ body, id }) => client.patch(`config/${id}`, body);

export const deleteConfigRequest = (id) => client.delete(`config/${id}`);

export const publishRequestRequest = (data) => client.post("publish-request/schedule", data);

export const scheduleCITestsRequest = (data) => client.post("config-ci-test-task/schedule", data);
